const bootstrap = require('./bootstrap');
const Vue = require('vue');
const $ = require('jquery');
const AppConstants = require('./constants/constants').default;
const EventBus = require('./libraries/eventbus').default;
const utils = require('./libraries/utils').default;
const Clib = require('./libraries/clib').default;
const StateLib = require('./libraries/stateLib').default;
const {Socket} = require('./libraries/socket');

const Highcharts = require('highcharts');
import HighchartsVue from 'highcharts-vue';
require('highcharts-multicolor-series')(Highcharts);

window.Vue = Vue;
window.$ = $;
window.utils = utils;
window.EventBus = EventBus;
window.AppConstants = AppConstants;
window.Clib = Clib;
window.StateLib = StateLib;
window.store = require('./stores/index').default;

const trans = {
    install: function (_Vue) {
        if(!_Vue.prototype.$trans) {
            _Vue.prototype.$trans = function (key, value) {
                let trans = store.state.language_pack[key] ? store.state.language_pack[key] : key;
                // console.log(key, typeof value)
                if (typeof value == 'object') {
                    return utils.replace(trans, value);
                } else {
                    return trans;
                }
            }
        }
    }
};

Vue.use(require('vue-moment'));
Vue.use(HighchartsVue);
Vue.use(trans);
Vue.config.productionTip = false;

const socket = new Socket();
const theme = utils.cookie.get('_theme') || 'black';

const app = new Vue({
    el: '#app',
    components: {
        'game-wrapper': require('./components/game-wrapper.vue').default,
    },
    store: store,
    data()
    {
        let language = 'en_US';
        let language_name = 'English';

        try {
            language = localStorage['language'] ? localStorage['language'] : 'en_US';
            language_name = localStorage['language_name'] ? localStorage['language_name'] : 'English';
        } catch (e) {}

        return {
            state: {
                socket: null,
                set: this.setState,

                title: process.env.MIX_FRONT_TITLE,
                theme: theme,

                // language: localStorage['language'] ? localStorage['language'] : 'en_US',
                language: language,
                language_name: language_name,
                languages: [],

                /** The engine is connected to the server, if not connected, all fields are unreadable */
                is_connected: false,

                rendering: false,

                status: null, // ready, stopped, disconnected, expired

                is_ready: false,

                is_small:  false,

                control_size: 'big', // big, small

                graph_mode: 'graphics', // graphics, text

                user_class: null,

                /** The username or null if is not logged in */
                username: null,

                user_id: null,

                /** The currency of the user */
                currency: null,

                /** The balance of the user */
                balance: 0,

                /** Max bet will be sent by the server in the future, for now is a constant **/
                max_bet: AppConstants.Engine.MAX_BET,

                min_bet: 1000,

                bet_amount_range: [1000, 5000, 10000, 50000, 100000],

                /** Object containing the game history */
                game_history: [],

                /** Object containing the chat history */
                chat_messages: [],

                /** Array of the user names of the current players who joined the game, while the game is STARTING
                 * sorted by bet by the server but the client doesn't know the bet amount
                 * its empty in the other states */
                joined: [],

                /** Object containing the current game players and their status, this is saved in game history every game crash
                 * cleared in game_starting.
                 * e.g: { user1: { bet: amount, stopped_at: 200 }, user2: { bet: amount } }
                 */
                player_info: {},

                /**
                 * The state of the game
                 * Possible states: IN_PROGRESS, ENDED, STARTING
                 */
                game_state: null,

                /** Creation time of current game. This is the server time, not clients.. **/
                created: null,

                /** The game id of the current game */
                game_id: null,

                /** How much can be won this game */
                max_profit: 0,

                /**
                 * Client side times:
                 * if the game is pending, startTime is how long till it starts
                 * if the game is running, startTime is how long its running for
                 * if the game is ended, startTime is how long since the game started
                 */
                start_time: null,

                /** time from the game_starting event to game_started event **/
                time_till_start: null,

                /** If you are currently placing a bet
                 * True if the bet is queued (nextBetAmount)
                 * True if the bet was sent to the server but the server has not responded yet
                 *
                 * Cleared in game_started, its possible to receive this event before receiving the response of
                 */
                placing_bet: false,

                /** True if cashing out.. */
                cashing_out: false,

                /**
                 * If a number, how much to bet next round
                 * Saves the queued bet if the game is not 'game_starting', cleared in 'bet_placed' by us and 'game_started' and 'cancel bet'
                 */
                next_bet_amount: null,

                current_bet_amount: null,

                /** Complements nextBetAmount queued bet with the queued autoCashOut */
                next_auto_cash_out: null,

                /** Store the id of the timer to check for lag **/
                tick_timer: null,

                /** Tell if the game is lagging but only  when the game is in progress **/
                lag: false,

                /** The hash of the last game **/
                last_hash: null,

                /** Animation Events triggers**/
                nyan: false,

                last_game_tick: null,

                game_at: 0,

                play_state: 'idle', // idle, queue, betting, playing

                mounted_components: [],

                game_play_info: {
                    online: 0,
                    playing_count: 0,
                    betting_amount: 0,
                },

                display_active_controls_tab: 'history',
                display_masked_username: true,
                display_hash_checker: true,
                display_play_info: true,
                is_chat: true,
                nyan_cat_trigger_ms: 0,

                modals: {
                    user_stats: {
                        display: false,
                        data: {},
                    },
                    game_information: {
                        display: false,
                        data: {},
                    }
                },
            },
        }
    },
    created()
    {
        /**
         * Set parameter lang
         * @type {URLSearchParams}
         */
        let queries = new URLSearchParams(window.location.search);
        if (queries.get('lang')) {
            this.state.language = queries.get('lang');
        }

        // console.log('app created');
        window.addEventListener('resize', this.onWindowResize.bind(this));

        // console.log('Events on')
        /**
         * Components loaded event
         */
        EventBus.$on('set_state', this.setState);
        EventBus.$on('push_component', this.pushComponent);

        EventBus.$on('game_starting', this.onChange);
        EventBus.$on('game_started', this.onChange);
        EventBus.$on('game_crash', this.onChange);
        EventBus.$on('lag_change', this.onChange);
        EventBus.$on('nyan_cat_animation', this.onChange);
        EventBus.$on('placing_bet', this.onChange);
        EventBus.$on('bet_placed', this.onChange);

    },
    mounted()
    {
        // console.log('app mounted');
        this.state.is_small = Clib.isMobileOrSmall();
        this.state.socket = socket.connect(this);
    },
    updated()
    {
        // console.log('app updated');
    },
    methods: {
        onWindowResize()
        {
            this.state.is_small = Clib.isMobileOrSmall();
        },
        setState(event, states)
        {
            _.merge(this.state, states);
        },
        pushComponent(component)
        {
            this.state.mounted_components.push(component);
            // console.log('######## Mounted component: ', component)
        },
        onChange()
        {
            if (this.state.nyan === true && this.state.game_state !== 'IN_PROGRESS') {
                this.state.nyan = false;
            }
        },
    },
});
